import AccessGroupsTableChipList from './AccessGroupsTableChipList';

export default AccessGroupsTableChipList;
